export default "__VITE_ASSET__CSBnneUh__"